module.exports = __webpack_public_path__ + "static/media/clock-desktop.3a5c2ffb.svg";